module.exports = __webpack_public_path__ + "static/media/contemplar_te_5.610d4797.jpg";